import { useMutation } from '@gogame/query';
import { useScreenMessage } from '@gogame/screens';

import { exportFromGoogleDrive } from '../../sources/table';
import { exportGoogleDrive } from '../queryKeyFactory';

export const useExportToGoogleDrive = (stateParams) => {
  const { showMessage } = useScreenMessage();

  const exportMutation = useMutation(
    exportGoogleDrive(),
    exportFromGoogleDrive,
    {
      refresh: false,
      onSuccess: ({ fileId }) => {
        window.open(
          `https://docs.google.com/spreadsheets/d/${fileId}`,
          '_blank'
        );
      },
    }
  );
  const handleAction = (params) => {
    showMessage(`Your report will be opened in the next tab when it is ready `);

    exportMutation.mutateAsync({
      ...params,
      ...stateParams,
    });
  };

  return [handleAction, exportMutation];
};
